import * as React from 'react'

interface IProps {
  fallback?: string
  className?: string
}

const NextGenImageWrapper: React.FC<IProps> = ({
  fallback = 'png',
  className = '',
  children
}) => {
  const sources = React.Children.map(children, (child: React.ReactElement) => {
    const originalSrc = child.props.src || child.props.srcSet
    const fallbackSrc = originalSrc.replace('.webp', `.${fallback}`)

    if (child.type === 'img') {
      return (
        <>
          <source srcSet={originalSrc} type="image/webp" />
          {React.cloneElement(child, { src: fallbackSrc })}
        </>
      )
    }

    return (
      <>
        {React.cloneElement(child, { type: 'image/webp' })}
        {React.cloneElement(child, { srcSet: fallbackSrc })}
      </>
    )
  })

  return <picture className={className}>{sources}</picture>
}

export default NextGenImageWrapper
